import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=a384d28e&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=js&"
export * from "./pc.vue?vue&type=script&lang=js&"
import style0 from "./pc.vue?vue&type=style&index=0&id=a384d28e&prod&lang=less&"
import style1 from "./pc.vue?vue&type=style&index=1&id=a384d28e&prod&lang=less&scoped=true&"
import style2 from "./pc.vue?vue&type=style&index=2&id=a384d28e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a384d28e",
  null
  
)

export default component.exports